import React from 'react'
import { Link } from 'react-router-dom';
import "./RegLog.css";

const Registration = () => {
  return (
    <div>
      <section className="vh-150 bg-image backImage m-5">
                  <div className="mask d-flex align-items-center h-100 gradient-custom-3">
                    <div className="container h-100">
                      <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-12 col-md-9 col-lg-7 col-xl-6">
                          <div className="card" style={{border_radius: "15px"}}>
                            <div className="card-body p-5">
                              <h2 className="text-uppercase text-center mb-5">
                                Create an account
                              </h2>
                              <form>
                                <div className="form-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    name="name"
                                  />
                                  <label
                                    className="form-label"
                                    for="name"
                                  >
                                    Your Name
                                  </label>
                                </div>

                                <div className="form-outline mb-4">
                                  <input
                                    type="email"
                                    className="form-control form-control-lg"
                                    name="email"
                                  />
                                  <label
                                    className="form-label"
                                    for="email"
                                  >
                                    Your Email
                                  </label>
                                </div>

                                <div class="form-outline mb-4">
                                  <input
                                    type="password"
                                    class="form-control form-control-lg"
                                    name="password"
                                  />
                                  <label
                                    className="form-label"
                                    for="password"
                                  >
                                    Password
                                  </label>
                                </div>

                                <div class="form-outline mb-4">
                                  <input
                                    type="password"
                                    class="form-control form-control-lg"
                                    name="cpassword"
                                  />
                                  <label
                                    className="form-label"
                                    for="cpassword"
                                  >
                                    Repeat your password
                                  </label>
                                </div>

                                <div className="form-check d-flex justify-content-center mb-5">
                                  <input
                                    className="form-check-input me-2"
                                    type="checkbox"
                                    value=""
                                  />
                                  <label
                                    className="form-check-label"
                                    for="form2Example3g"
                                  >
                                    I agree all statements in{" "}
                                    <a href="#!" class="text-body">
                                      <u>Terms of service</u>
                                    </a>
                                  </label>
                                </div>

                                <div className="d-flex justify-content-center">
                                  <button
                                    type="button"
                                    className="btn btn-success btn-block btn-lg gradient-custom-4 text-body"
                                  >
                                    Register
                                  </button>
                                </div>

                                <p className="text-center text-muted mt-5 mb-0">
                                  Have already an account?{" "}
                                  <Link to="/login" className="fw-bold text-body text-decoration-none">
                                    Login here
                                  </Link>
                                </p>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
    </div>
  )
}

export default Registration
